import { Request } from "../Request";

export const uploadData = async (data: any) => {
  return Request.post("/setting", { data: data });
};

export const getData = async () => {
  return Request.get(`/settings/get-data`, {});
};
